module.exports = __webpack_public_path__ + "static/img/qwlogo.f860ae1c.png";